import { useMemo } from 'react'

import { Tag, Tooltip } from 'antd'

import { isNonEmptyArray, isPositive } from '../../../utils'
import { TagColors } from './ColoredTag'

const TITLE_STYLE = { padding: '0', margin: '0', listStyleType: 'none' }

const CompactedList = ({ items, component, overflow = 1, overflowTagColor = TagColors.BLUE }) => {
  const list = useMemo(() => {
    let toDisplay = []
    let toHide = []

    if (isNonEmptyArray(items)) {
      toDisplay = items.slice(0, isPositive(overflow, true) ? overflow : 1)
      toHide = items.slice(overflow)
    }

    return { toDisplay, toHide }
  }, [items, overflow])

  const ListItem = useMemo(() => component ?? 'span', [component])

  return (
    <div>
      {list.toDisplay.map((item, i) => <ListItem key={`${item}_${i}`}>{item}</ListItem>)}
      {isNonEmptyArray(list.toHide) && (
        <Tooltip
          overlayStyle={{ maxWidth: 'none' }}
          title={
            <ul style={TITLE_STYLE}>
              {list.toHide.map((item, i) => <li key={`${item}_${i}`}>{item}</li>)}
            </ul>
          }
        >
          <Tag className='ml-4-i' color={overflowTagColor}>
            +{list.toHide.length}
          </Tag>
        </Tooltip>
      )}
    </div>
  )
}

export default CompactedList